import { Injectable } from '@angular/core';
 
@Injectable()
export class ErrorHandler {
	public onlineFlag = navigator.onLine;
 
	constructor() {}
 
	public handleError(err: any) {
		console.log(err.message);
		if(err.status == 401){
			window.localStorage.clear();
		}
		else if(!this.onlineFlag) {
			alert("Internet connection lost");
			window.localStorage.clear();
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/auth/error-handler.ts